<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <!--                <el-col :span="4" :xs="12">-->
        <!--                    <el-form-item prop="deviceId">-->
        <!--                        <el-select-->
        <!--                                v-model="params.deviceId"-->
        <!--                                :loading="loadingDevice"-->
        <!--                                :remote-method="remoteMethodDevice"-->
        <!--                                id="el-select"-->
        <!--                                @focus="closeReadOnly"-->
        <!--                                @hook:mounted="closeReadOnly"-->
        <!--                                @visible-change="closeReadOnly"-->
        <!--                                filterable-->
        <!--                                placeholder="请输入电站名"-->
        <!--                                remote-->
        <!--                                reserve-keyword>-->
        <!--                            <el-option-->
        <!--                                    v-for="(item,index) in optionsDevice"-->
        <!--                                    :key="index"-->
        <!--                                    :label="item.name"-->
        <!--                                    :value="item.id"/>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--                <el-col :span="4" :xs="12">-->
        <!--                    <el-form-item prop="ids">-->
        <!--                        <el-input v-model="params.ids" maxlength="6" placeholder="输入ids号查询"/>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <el-col :span="5" :xs="24">
          <SearchByMemberAndCard2 ref="SearchByMemberAndCard2" />
        </el-col>
        <!--        <el-col :span="3" :xs="24">-->
        <!--          <el-form-item prop="thirdPartyOrderId">-->
        <!--            <el-input v-model="params.carportName" maxlength="32" placeholder="车库"/>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col :span="2" :xs="12">
          <el-form-item prop="ids">
            <el-input
              v-model="params.ids"
              maxlength="11"
              placeholder="门禁UID"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7" :xs="24">
          <el-form-item prop="thirdPartyOrderId">
            <!-- <el-date-picker
                v-model="time"
                :clearable="false"
                :picker-options="pickerOptions"
                end-placeholder="结束日期"
                range-separator="至"
                start-placeholder="开始日期"
                type="daterange"
                value-format="timestamp"/> -->
            <lp-date-picker
              ref="lpDatePicker"
              @finish="handleLpDatePickerChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
      :default-sort="{ prop: 'id', order: 'descending' }"
    >
      <el-table-column label="ID" prop="id" width="100" />

      <el-table-column label="用户名称" algin="center">
        <template #default="scope">
          {{ scope.row.memberInfo.name }}
        </template>
      </el-table-column>
      <el-table-column label="手机号/电卡" algin="center">
        <template #default="scope">
          {{
            scope.row.memberInfo.phone === "0"
              ? "未绑定"
              : scope.row.memberInfo.phone
          }}
        </template>
      </el-table-column>
      <el-table-column label="订单类型">
        <template #default="scope">
          <span v-if="scope.row.memberType == 1">微信</span>
          <span v-else-if="scope.row.memberType == 3">电卡</span>
          <span v-else-if="scope.row.memberType == 7">支付宝</span>
          <span v-else>其他</span>
          -
          <span v-if="scope.row.orderType === 1">临停</span>
          <span v-else>包月</span>
        </template>
      </el-table-column>
      <!--      <el-table-column fixed label="订单号" prop="orderSn" width="145"/>-->
      <el-table-column label="所属车库">
        <template #default="scope">
          {{ scope.row.carport.name }}
        </template>
      </el-table-column>
      <el-table-column label="门禁UID">
        <template #default="scope">
          {{ scope.row.ids }}
        </template>
      </el-table-column>

      <el-table-column label="金额" prop="money" />
      <el-table-column label="支付方式">
        <template slot-scope="scope">
          <template v-if="scope.row.orderType !== 1">
            <span>包月</span>
          </template>
          <template v-else>
            <span v-if="scope.row.moneyType === 1">余额</span>
            <span v-else-if="scope.row.moneyType === 2">豆币</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="时间">
        <template #default="scope">
          {{ timeFormat(scope.row.startTime) }}
        </template>
      </el-table-column>
      <el-table-column label="方向">
        <template #default="scope">
          <span v-if="scope.row.direction === 1">入</span>
          <span v-else>出</span>
        </template>
      </el-table-column>
      <el-table-column label="开门方式">
        <template #default="scope">
          <span v-if="scope.row.rfCardId && scope.row.rfCardId > 0"
            >射频卡</span
          >
          <span v-else>扫码/刷卡</span>
        </template>
      </el-table-column>
      <!--            <el-table-column label="操作" width="220">-->
      <!--                <template #default="scope">-->
      <!--                    <el-button size="mini" type="success" v-if="scope.row.direction===1&&scope.row.orderType===1" @click="refundOrder(scope.row.id)">退单-->
      <!--                    </el-button>-->
      <!--                </template>-->
      <!--            </el-table-column>-->
      <el-table-column label="操作" width="220">
        <template #default="scope">
          <el-button
            v-if="
              scope.row.orderType == 1 &&
              scope.row.money > 0 &&
              scope.row.isRefund === '0' &&
              scope.row.moneyType === 1
            "
            size="mini"
            type="success"
            @click="refundOrder(scope.row.id)"
            >退单
          </el-button>
          <el-button
            v-else-if="scope.row.isRefund === '1'"
            disabled
            size="mini"
            type="info"
            >已退单
          </el-button>
          <span v-else>不可退单</span>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <OrderDetailsDialog :id="id" :dialog="orderDetailsDialog" />
    <finish-order-dialog :id="id" :dialog="finishOrderDialog" />
    <wave-dialog :id="id" :dialog="waveDialog" />
    <refund-parking-order-dialog :id="id" :dialog="refundParkingOrderDialog" />
  </div>
</template>

<script>
import ParkingRecord from "@/api/fund/ParkingRecord";
import FinishOrderDialog from "@/components/Dialog/finishOrderDialog";
import OrderDetailsDialog from "@/components/Dialog/orderDetailsDialog";
import refundParkingOrderDialog from "@/components/Dialog/refundParkingOrderDialog";
import WaveDialog from "@/components/Dialog/waveDialog";
import Page from "@/components/Page";
import SearchByMemberAndCard2 from "@/components/SearchByMemberAndCard2";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import getDeviceMixin from "@/mixin/getDeviceMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";

export default {
  name: "ParkingOrder",
  components: {
    refundParkingOrderDialog,
    WaveDialog,
    FinishOrderDialog,
    OrderDetailsDialog,
    Page,
    SearchByMemberAndCard2,
  },
  mixins: [
    pageMixin,
    createdMixin,
    timeMixin,
    searchMixin,
    dialogMixin,
    getDeviceMixin,
  ],
  data() {
    return {
      waveDialog: false,
      id: undefined,
      finishOrderDialog: false,
      orderDetailsDialog: false,
      refundParkingOrderDialog: false,
      time: [],
      records: [],
      params: {
        deviceId: undefined,
        carportName: undefined,
        ids: undefined,
        socketNum: undefined,
        memberId: undefined,
        memberType: undefined,
        sortName: "id",
        sortType: "DESC",
      },
    };
  },
  methods: {
    resetFields() {
      this.params = {
        deviceId: undefined,
        carportName: undefined,
        ids: undefined,
        socketNum: undefined,
        memberId: undefined,
        memberType: undefined,
        sortName: "id",
        sortType: "DESC",
      };
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    closeReadOnly(val) {
      this.$nextTick(() => {
        if (!val) {
          const timer = setTimeout(() => {
            document.getElementById("el-select").removeAttribute("readonly");
            clearTimeout(timer);
          }, 200);
        }
      });
    },
    refundOrder(id) {
      this.id = id;
      this.refundParkingOrderDialog = true;
    },
    wave(id) {
      this.id = id;
      this.waveDialog = true;
    },
    detail(id) {
      this.id = id;
      this.orderDetailsDialog = true;
    },
    finish(id) {
      this.id = id;
      this.finishOrderDialog = true;
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;
      ParkingRecord.agentGetParkingRecord(this.params)
        .then((res) => {
          this.total = res.data.total;
          this.records = res.data.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
  },
};
</script>
